/**
 * Note History Event Types and Interfaces
 */

export enum NoteHistoryEventType {
  NoteCreated = 'NoteCreated',
  NoteUpdated = 'NoteUpdated',
  TitleChanged = 'TitleChanged',
  ContentChanged = 'ContentChanged',
  LocationAdded = 'LocationAdded',
  LocationChanged = 'LocationChanged',
  LocationRemoved = 'LocationRemoved',
  NoteDeleted = 'NoteDeleted',
  AttachmentAdded = 'AttachmentAdded',
  AttachmentDeleted = 'AttachmentDeleted',
  ImageUploaded = 'ImageUploaded',
}

export interface NoteHistoryEvent {
  id: string;
  noteId: string;
  eventType: NoteHistoryEventType;
  description: string;
  authorId: string;
  authorName: string;
  authorAvatarUrl: string | null;
  metadata: { oldValue?: string; newValue?: string } | null;
  createdAt: string;
}

export interface NoteHistoryResponse {
  events: NoteHistoryEvent[];
}
